module.exports = __webpack_public_path__ + "static/media/roc1.e5459d89.gif";